import React from "react";
import { IconCheckmark, IconNoCheckmark, IconSwitchOff, IconSwitchOn } from "../icons/svg";

class CheckBox extends React.Component {
   constructor(props) {
      super(props);

      this.getStatusSwitch = this.getStatusSwitch.bind(this);
      this.handleClickSwitch = this.handleClickSwitch.bind(this);
   }

   getStatusSwitch() {
      return !!this.props.status;
   }

   handleClickSwitch() {
      typeof this.props.onClick === 'function' && this.props.onClick();
   }

   render() {
      return (
         <div className="switch" onClick={this.handleClickSwitch}>
            {this.getStatusSwitch() ? <IconCheckmark /> : <IconNoCheckmark />}
         </div>
      )
   }
}

export default CheckBox;